import { GlPopover, GlBadge, GlIcon } from '@gitlab/ui';
import { __ } from '~/locale';
import WorkItemTypeIcon from '~/work_items/components/work_item_type_icon.vue';
import WorkItemRolledUpCountInfo from './work_item_rolled_up_count_info.vue';
export default {
    name: 'WorkItemRolledUpCount',
    i18n: {
        countPermissionText: __('Roll up totals may reflect child items you don’t have access to.'),
        noChildItemsText: __('No child items are currently assigned.')
    },
    components: {
        GlPopover,
        GlBadge,
        GlIcon,
        WorkItemTypeIcon,
        WorkItemRolledUpCountInfo
    },
    props: {
        infoType: {
            type: String,
            required: false,
            default: 'badge'
        },
        rolledUpCountsByType: {
            type: Array,
            required: true
        },
        hideCountWhenZero: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        totalCountAllByType () {
            return [
                ...this.rolledUpCountsByType
            ].reduce((total, rollUpCounts)=>total + rollUpCounts.countsByState.all, 0);
        },
        showDetailedCount () {
            return this.infoType === 'detailed';
        },
        filteredRollUpCountsByType () {
            return this.rolledUpCountsByType.filter((rollUpCount)=>this.rolledUpCountExists(rollUpCount));
        },
        showRolledUpCount () {
            return this.hideCountWhenZero ? this.totalCountAllByType > 0 : true;
        }
    },
    methods: {
        rolledUpCountExists (rolledUpCount) {
            return rolledUpCount?.countsByState?.all > 0;
        }
    }
};
